import { render, staticRenderFns } from "./myWorks.vue?vue&type=template&id=6ba2112e&scoped=true"
import script from "./myWorks.vue?vue&type=script&lang=js"
export * from "./myWorks.vue?vue&type=script&lang=js"
import style0 from "./myWorks.vue?vue&type=style&index=0&id=6ba2112e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2112e",
  null
  
)

export default component.exports